import { CheckOutlined, DownOutlined, GlobalOutlined } from "@ant-design/icons";
import { Dropdown, MenuProps } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import "./AuthLayout.less";

interface AuthLayoutProps {
  children: React.ReactNode;
}

/**
 * 认证页面布局组件
 * 用于登录、注册、忘记密码等认证相关页面
 * 包含公共的背景和卡片样式
 */
export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const { i18n } = useTranslation();

  const currentLang = i18n.language.startsWith("en") ? "English" : "简体中文";

  const changeLanguage = (lng: string) => {
    window.location.reload();
    setTimeout(() => {
      i18n.changeLanguage(lng);
    }, 0);
  };

  const langItems: MenuProps["items"] = [
    {
      key: "zh",
      label: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            color: i18n.language.startsWith("zh") ? "#21C4B8" : "#374151",
            fontWeight: i18n.language.startsWith("zh") ? 600 : 400,
          }}
        >
          <span>简体中文</span>
          {i18n.language.startsWith("zh") && (
            <CheckOutlined style={{ color: "#21C4B8", marginLeft: 8 }} />
          )}
        </div>
      ),
      onClick: () => changeLanguage("zh"),
    },
    {
      key: "en",
      label: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            color: i18n.language.startsWith("en") ? "#21C4B8" : "#374151",
            fontWeight: i18n.language.startsWith("en") ? 600 : 400,
          }}
        >
          <span>English</span>
          {i18n.language.startsWith("en") && (
            <CheckOutlined style={{ color: "#21C4B8", marginLeft: 8 }} />
          )}
        </div>
      ),
      onClick: () => changeLanguage("en"),
    },
  ];

  return (
    <div className="auth-page">
      {/* 语言切换器 - 右上角，在卡片外 */}
      <div className="auth-language-switcher">
        <Dropdown menu={{ items: langItems }} placement="bottomRight" arrow>
          <div className="auth-language-switcher-button">
            <GlobalOutlined
              style={{ fontSize: 16, color: "#374151", marginRight: 6 }}
            />
            <span style={{ color: "#374151", fontSize: 14, fontWeight: 400 }}>
              {currentLang}
            </span>
            <DownOutlined
              style={{ fontSize: 10, color: "#6b7280", marginLeft: 6 }}
            />
          </div>
        </Dropdown>
      </div>
      <div className="auth-container">
        <div className="auth-card">{children}</div>
      </div>
    </div>
  );
};

export default AuthLayout;
